var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"chat-msg-img img",attrs:{"src":_vm.value.content,"alt":"图片加载失败"},on:{"load":function($event){return _vm.$emit('image:load', $event)},"click":function($event){return _vm.$emit('preview', _vm.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }